import { render } from "./JobInfo.vue?vue&type=template&id=1ad04448&scoped=true"
import script from "./JobInfo.vue?vue&type=script&lang=js"
export * from "./JobInfo.vue?vue&type=script&lang=js"

import "./JobInfo.vue?vue&type=style&index=0&id=1ad04448&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad04448"]])

export default __exports__